export default class RevistaCreateRevistaController {
  constructor($q, $state, $scope, AuthenticationService, UIService, RevistaService, Revista, RevistaIndicador, RevistaEquipaEditorial, Ranking, RevistaEquipaEditorialFuncao, Investigador) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.RevistaService = RevistaService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Revista = Revista;
    this.RevistaIndicador = RevistaIndicador;
    this.RevistaEquipaEditorial = RevistaEquipaEditorial;
    this.Ranking = Ranking;
    this.RevistaEquipaEditorialFuncao = RevistaEquipaEditorialFuncao;
    this.Investigador = Investigador;

    this.emptyData = {
      form: 1,
      details: {},

      equipaEditorial: [],
      indicadores: [],
      auxScopus: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_RevistaNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    // No external data to load right away, so just continue
    this.loadDataFromStorage();
    this.loaded = true;
  };


  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_RevistaNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_RevistaNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);

      if (storageData.equipaEditorial) this.data.equipaEditorial = storageData.equipaEditorial; else this.data.equipaEditorial = angular.copy(this.emptyData.equipaEditorial);
      if (storageData.indicadores) this.data.indicadores = storageData.indicadores; else this.data.indicadores = angular.copy(this.emptyData.indicadores);

      if (storageData.auxScopus) this.data.auxScopus = storageData.auxScopus; else this.data.auxScopus = angular.copy(this.emptyData.auxScopus);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.revista.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.revista.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.revista.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Revista and related data
      this.data.details.id = 0;
      this.data.details.scopus = this.data.auxScopus.selected.value;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Revista.create(this.data.details).$promise.then((revista) => {

        // Create all Equipa Editorial
        let deferEquipaEditorial = this.$q.defer();
        this.RevistaService.createMultipleData(this.RevistaEquipaEditorial, this.data.equipaEditorial, revista.id, 'revistaId').then((x) => {
          deferEquipaEditorial.resolve({ok: true});
        }).catch(err => {
          deferEquipaEditorial.resolve({ok: false, output: 'Equipa Editorial'});
        });

        // Create all Indicadores
        let deferIndicadores = this.$q.defer();
        this.RevistaService.createMultipleData(this.RevistaIndicador, this.data.indicadores, revista.id, 'revistaId').then((x) => {
          deferIndicadores.resolve({ok: true});
        }).catch(err => {
          deferIndicadores.resolve({ok: false, output: 'Indicadores'});
        });

        // Check if any revista needs updating
        let deferPublicacao = this.$q.defer();
        this.RevistaService.checkRevistaPublicacao(revista).then((x) => {
          deferPublicacao.resolve({ok: true});
        }).catch(err => {
          deferPublicacao.resolve({ok: false, output: 'Atualização de associação de Revista a Publicações'});
        });

        let promises = [deferEquipaEditorial.promise, deferIndicadores.promise, deferPublicacao.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Revista criada com sucesso");

          localStorage.removeItem('ISR_SGI_RevistaNewForm');

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Revista criada, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.revista.details', {id: revista.id});
            });
          } else {
            this.state.go('app.revista.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_RevistaNewForm');
          alert = this.UI.showAlert("Revista criada, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.revista.details', {id: revista.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar revista. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if revista data is well defined
    // ISSN
    if (v && (!this.RevistaService.isValidISSN(this.data.details.issn))) {
      this.UI.addToast("ISSN inválido");
      v = false;
      validDefer.reject();
    }

    // ISSN Online (if filled)
    if (v && (this.data.details.issnOnline && this.data.details.issnOnline.length > 0 && !this.RevistaService.isValidISSN(this.data.details.issnOnline))) {
      this.UI.addToast("ISSN Online inválido");
      v = false;
      validDefer.reject();
    }

    // Nome
    if (v && (!this.data.details.nome || this.data.details.nome.length === 0)) {
      this.UI.addToast("Nome da Revista não preenchido");
      v = false;
      validDefer.reject();
    }
    // SCOPUS
    if (v && (!this.data.auxScopus || !this.data.auxScopus.selected)) {
      this.UI.addToast("Informação de SCOPUS inválida");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data - Since we can add any revista this can't be imposed anymore
    // if (v && (this.data.equipaEditorial.length === 0)) {
    //   this.UI.addToast("Equipa Editorial não preenchida");
    //   v = false;
    //   validDefer.reject();
    // }

    // Check if anos are unique for indicadores
    let anos = this.data.indicadores.map(x => x.ano);
    let anosRepetidos = anos.filter((x, i) => anos.indexOf(x) !== i);
    if (v && anosRepetidos.length > 0) {
      this.UI.addToast("Indicadores para " + anosRepetidos.toString() + " repetidos");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // Add multi async data to verify
      this.data.equipaEditorial.forEach(x => {
        idData.push({
          field: 'id',
          value: x.funcaoId,
          model: this.RevistaEquipaEditorialFuncao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Função inexistente"
        }, {
          field: 'id',
          value: x.investigadorId,
          model: this.Investigador,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Investigador inexistente"
        });
      });
      this.data.indicadores.forEach(x => {
        idData.push({
          field: 'id',
          value: x.rankingId,
          model: this.Ranking,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Ranking inexistente"
        });
      });

      // ISSN should always exist
      idData.push({
        field: 'issn',
        value: this.data.details.issn,
        model: this.Revista,
        resolveOnExist: false,
        error: "Já existe uma revista com este ISSN associado"
      });

      // If value is filled, we need to check if it exists already too
      if (this.data.details.issnOnline && this.data.details.issnOnline.length > 0) {
        idData.push({
          field: 'issn',
          value: this.data.details.issnOnline,
          model: this.Revista,
          resolveOnExist: false,
          error: "Já existe uma revista com este ISSN associado"
        }, {
          field: 'issnOnline',
          value: this.data.details.issn,
          model: this.Revista,
          resolveOnExist: false,
          error: "Já existe uma revista com este ISSN associado"
        }, {
          field: 'issnOnline',
          value: this.data.details.issnOnline,
          model: this.Revista,
          resolveOnExist: false,
          error: "Já existe uma revista com este ISSN associado"
        });
      }

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.RevistaService.validateMultiData(idData).then(x => {
        wait.close();
        validDefer.resolve();
      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs

  // Adicionar uma nova equipa editorial para revista
  addEquipaEditorial = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.RevistaEquipaEditorialFuncao.find({}).$promise.then((funcoes) => {
        wait.close();
        let options = {
          size: 'lg',
          template: require('./edit.equipa.editorial.dialog.html'),
          controller: ['$scope', '$dialog', ($scope, $dialog) => {
            $scope.membroEquipaEditorial = {};
            $scope.label = "Novo membro de Equipa Editorial";
            $scope.investigadores = investigadores;
            $scope.funcoes = funcoes;

            $scope.auxInvestigador = {
              selected: undefined,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            $scope.auxFuncao = {
              selected: undefined,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            $scope.removeDate = this.UI.removeDate;
            $scope.dateOptions = {
              dataEntrada: {format: 'DD/MM/YYYY'},
              dataSaida: {format: 'DD/MM/YYYY'}
            };

            // Infinite Scroll magic
            $scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            $scope.ok = () => {
              $dialog.close($scope);
            };

            $scope.cancel = () => {
              $dialog.dismiss('cancel');
            };
          }]
        };
        let dialogEdit = this.UI.showDialog(options);
        dialogEdit.then(ok => {
          if (ok.auxFuncao && ok.auxInvestigador && ok.membroEquipaEditorial) {
            let item = angular.copy(ok.membroEquipaEditorial);
            item.dataEntrada = item.dataEntrada.format(); // Use text instead of moment
            if (item.dataSaida != null && item.dataSaida.isValid()) // null, undefined or invalid date
              item.dataSaida = item.dataSaida.format(); // Use text instead of moment
            else
              item.dataSaida = null;
            item.funcaoId = ok.auxFuncao.selected.id;
            item.funcao = angular.copy(ok.auxFuncao.selected);
            item.investigadorId = ok.auxInvestigador.selected.id;
            item.investigador = angular.copy(ok.auxInvestigador.selected);

            this.data.equipaEditorial.push(item);
          }
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler funções para equipa editorial. Verifique a sua ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para equipa editorial. Verifique a sua ligação");
    });
  };

  // Edita informação de equipa editorial para revista
  editEquipaEditorial = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.RevistaEquipaEditorialFuncao.find({}).$promise.then((funcoes) => {
        wait.close();
        let options = {
          size: 'lg',
          template: require('./edit.equipa.editorial.dialog.html'),
          controller: ['$scope', '$dialog', ($scope, $dialog) => {
            $scope.membroEquipaEditorial = angular.copy(x);
            $scope.label = "Editar membro de Equipa Editorial";
            $scope.funcoes = funcoes;
            $scope.investigadores = investigadores;

            $scope.auxInvestigador = {
              selected: $scope.membroEquipaEditorial.investigador,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };
            $scope.auxFuncao = {
              selected: $scope.membroEquipaEditorial.funcao,
              infiniteScroll: {numToAdd: 20, currentItems: 20}
            };

            // Infinite Scroll magic
            $scope.addMoreItems = (infiniteScroll) => {
              infiniteScroll.currentItems += infiniteScroll.numToAdd;
            };

            $scope.removeDate = this.UI.removeDate;
            $scope.dateOptions = {
              dataEntrada: {format: 'DD/MM/YYYY'},
              dataSaida: {format: 'DD/MM/YYYY'}
            };

            $scope.ok = () => {
              $dialog.close($scope);
            };

            $scope.cancel = () => {
              $dialog.dismiss('cancel');
            };
          }]
        };
        let dialogEdit = this.UI.showDialog(options);
        dialogEdit.then(ok => {
          if (ok.auxFuncao && ok.auxInvestigador && ok.membroEquipaEditorial) {
            // Update data without replacing the variable x (so it's still an element of the array)
            x.dataEntrada = ok.membroEquipaEditorial.dataEntrada.format(); // Use text instead of moment
            if (ok.membroEquipaEditorial.dataSaida != null && ok.membroEquipaEditorial.dataSaida.isValid()) // null, undefined or invalid date
              x.dataSaida = ok.membroEquipaEditorial.dataSaida.format(); // Use text instead of moment
            else
              x.dataSaida = null;

            x.funcaoId = ok.auxFuncao.selected.id;
            x.funcao = angular.copy(ok.auxFuncao.selected);
            x.investigadorId = ok.auxInvestigador.selected.id;
            x.investigador = angular.copy(ok.auxInvestigador.selected);
          }
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler funções de equipa editorial. Verifique a sua ligação");
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
    });
  };

  // Remove Equipa Editorial com índice index
  removeEquipaEditorial = (index) => {
    if (index < this.data.equipaEditorial.length) {
      this.data.equipaEditorial.splice(index, 1);
    }
  };


  // Adicionar uma nova indicador para investigador
  addIndicador = () => {
    let wait = this.UI.showWaiting();
    this.Ranking.find({}).$promise.then((rankings) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.indicador.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.indicador = {};
          $scope.label = "Novo Conjunto de Indicadores para Revista";
          $scope.rankings = rankings;

          // Current year as max be able to add indicadores
          $scope.year = moment().format('YYYY');

          $scope.auxRanking = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxRanking && ok.indicador) {
          let item = angular.copy(ok.indicador);

          item.rankingId = ok.auxRanking.selected.id;
          item.ranking = ok.auxRanking.selected;

          this.data.indicadores.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler rankings para indicadores. Verifique a sua ligação");
    });

  };

  // Edita informação de indicador para investigador
  editIndicador = (x) => {
    let wait = this.UI.showWaiting();
    this.Ranking.find({}).$promise.then((rankings) => {
      wait.close();
      let options = {
      size: 'lg',
      template: require('./edit.indicador.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.indicador = angular.copy(x);
        $scope.label = "Editar Conjunto de Indicadores para Revista";
        $scope.rankings = rankings;

        // Current year as max be able to add citacoes
        $scope.year = moment().format('YYYY');

        $scope.auxRanking = {
          selected: $scope.indicador.ranking,
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      if (ok.auxRanking && ok.indicador) {
        x.ano = ok.indicador.ano;
        x.impactFactor = ok.indicador.impactFactor;
        x.eigenFactor = ok.indicador.eigenFactor;

        x.rankingId = ok.auxRanking.selected.id;
        x.ranking = angular.copy(ok.auxRanking.selected);

      }
    });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler rankings para indicadores. Verifique a sua ligação");
    });
  };

  // Remove indicador com índice index
  removeIndicador = (index) => {
    if (index < this.data.indicadores.length) {
      this.data.indicadores.splice(index, 1);
    }
  };

}

RevistaCreateRevistaController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'RevistaService', 'Revista', 'RevistaIndicador', 'RevistaEquipaEditorial', 'Ranking', 'RevistaEquipaEditorialFuncao', 'Investigador'];
